import React from "react";

const AccountReservation: React.FC = () => {
  // const [reservation, setReservation] = useState([]);
  const reservation = [];

  return (
    <React.Fragment>
      <h3>Twoje rezerwacje</h3>
      {reservation.length === 0 && (
        <div className={"docs-panel-empty"}>
          <h2>Czegoś tu brakuje?</h2>
          <p>Najwyższa pora to zmienić, zachęcamy do rezerwacji.</p>
        </div>
      )}
    </React.Fragment>
  );
};

export default AccountReservation;
